import { Injectable } from "@angular/core";
import { Apollo, Mutation } from "apollo-angular";
import { gql } from "apollo-angular";
import { DeleteScoringCriteriaDto } from "src/app/service/financial.service";
import { Exact } from "src/generated/graphql";


export type DeleteScoringCriteriaMutationVariables = Exact<{
  id: DeleteScoringCriteriaDto;
}>;


export type DeleteScoringCriteriaMutation = {
  deleteScoringCriteria: boolean;
};


export const DeleteScoringCriteriaDocument = gql`
  mutation DeleteScoringCriteria($id: DeleteScoringCriteriaDto!) {
    deleteScoringCriteria(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteScoringCriteriaGQL extends Mutation<
  DeleteScoringCriteriaMutation,
  DeleteScoringCriteriaMutationVariables
> {
  document = DeleteScoringCriteriaDocument; 

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
